import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import React, { useRef, useState } from 'react';
import useIsMobile from '../../../hooks/utils/useIsMobile';
import useOutsideClick from '../../../hooks/utils/useOutsideClick';

interface HoverWrapperProps {
  Icon: React.FC<any>;
  onEdit?: () => any;
  onDelete?: () => any;
  isLastDate?: boolean;
}

export const HoverWrapper: React.FC<HoverWrapperProps> = ({
  Icon,
  onEdit,
  onDelete,
  isLastDate,
}) => {
  const isMobile = useIsMobile();
  const [hovered, setHovered] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  useOutsideClick(popupRef, () => {
    if (hovered) {
      setHovered(false);
    }
  });
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
      onMouseEnter={
        !isMobile
          ? () => {
              setHovered(true);
            }
          : undefined
      }
      onMouseLeave={
        !isMobile
          ? () => {
              setHovered(false);
            }
          : undefined
      }
      onClick={() => {
        setHovered(prev => !prev);
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Icon />
      </div>
      {hovered && (onEdit || onDelete) && (
        <div
          ref={popupRef}
          style={{
            position: 'absolute',
            [isLastDate ? 'right' : 'left']: '101%',
            bottom: '0',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            boxShadow: '0 0.2rem 0.8rem rgba(0, 0, 0, 0.15)',
            borderRadius: '0.8rem',
            zIndex: '1',
          }}
          onClick={() => {
            setHovered(false);
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {onEdit && (
            <div
              style={{ padding: '1rem', cursor: 'pointer' }}
              onClick={() => {
                onEdit();
              }}
            >
              <EditOutlined />
            </div>
          )}

          <div
            style={{
              padding: onEdit ? '0 1rem 1rem' : '1rem',
              cursor: 'pointer',
            }}
            onClick={() => {
              onDelete?.();
            }}
          >
            <DeleteOutlined />
          </div>
        </div>
      )}
    </div>
  );
};
